import React from "react";
import { activityComboApi as api } from "../api/ActivityCombo.api";
import ActivityLoader from "activity/componenets/ActivityLoader";
import { Card, Row, Col, ListGroup, Badge } from "react-bootstrap";

function ActivityComboCard() {
  const { data, isLoading } = api.useGetAllCombosQuery("");
  if (isLoading) return <ActivityLoader />;

  return (
    <div className="container mt-4">
      {data.result.map((tour) => (
        <TourCard key={tour.id} tour={tour} />
      ))}
    </div>
  );
}

const TourCard = ({ tour }) => {
  return (
    <Card className="mb-4 w-100">
      <Card.Header as="h5">
        {tour.name}{" "}
        <Badge bg="success" className="ms-2">
          Discount: {tour.currency} {tour.amount}/-
        </Badge>
      </Card.Header>
      <Card.Body>
        <Card.Text>
          <strong>Created At:</strong>{" "}
          {new Date(tour.createdAt).toLocaleString()}
        </Card.Text>

        {tour.tourOptions.map((option, idx) => (
          <div key={option.id} className="mb-3">
            <h6 className="text-primary">
              {idx + 1}. {option.name}
            </h6>
            {option.description && <p>{option.description}</p>}

            {/* Ticket Rates */}
            {option.ticketRates.length > 0 && (
              <>
                <strong>🎟️ Ticket Rates</strong>
                <ListGroup className="mb-2">
                  {option.ticketRates.map((rate) => (
                    <ListGroup.Item key={rate.id}>
                      Adult: {rate.adultAmount} | Child: {rate.childAmount} |
                      Per Pax: {rate.isPerPax ? "Yes" : "No"}
                      <br />
                      Valid: {rate.validFromDate} to {rate.validTillDate}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}

            {/* Transfer Rates */}
            {option.transferRates.length > 0 && (
              <>
                <strong>🚐 Transfer Rates</strong>
                <ListGroup>
                  {option.transferRates.map((rate) => (
                    <ListGroup.Item key={rate.id}>
                      Type: {rate.transferType} | Sharing: {rate.sharingBasis} |
                      Amount: {rate.amount} | Per Pax:{" "}
                      {rate.isPerPax ? "Yes" : "No"}
                      <br />
                      Pax Range: {rate.minPax ?? "-"} to {rate.maxPax ?? "-"}
                      <br />
                      Valid: {rate.validFromDate} to {rate.validTillDate}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default ActivityComboCard;
